import { T as Typography, d as defineCustomElement$1 } from './p-c953c88d.js';
const OwcTypography = Typography;
const defineCustomElement = defineCustomElement$1;
export { OwcTypography, defineCustomElement };